import type { Link } from "../../../../aysa_api/features/link/v1/link.types";

export enum LinkType {
  LINK_TYPE_UNSPECIFIED = 0,
  LINK_TYPE_CONTACT = 1,
  LINK_TYPE_SECOND_HAND_SERVICE = 2,
}

export interface MetaLink {
  link: Link;
  type: LinkType;
}
